<!--
/**
* @name: AttributeAdd.vue
* @description: 添加/编辑属性
* @author: 于海威
* @create: 2020/08/24 18:13:50
* @update: 2020/08/24 18:13:50
*/
-->

<template>
  <y-view :loading="isLoading">
    <template v-if="!isView">
      <y-form titleAlign="right" titleWidth="100px" contentWidth="100%">
        <y-form-item title="属性ID:">
          <k-input disabled :class="css.inputW" placeholder="按照编码规则自动生成" block v-model="editPara.id"></k-input>
        </y-form-item>
        <y-form-item title="属性名称:" required>
          <k-input :class="css.inputW" placeholder="请输入属性名称" clearable block v-model="editPara.name"></k-input>
        </y-form-item>
        <y-form-item title="属性值:" required align="top">
          <y-button :class="css.btnW" icon="k-icon-add" @click="onAddAttribute" type="primary" v-if="valueList.length === 0">添加属性值</y-button>
          <div v-for="(item, index) in valueList" :key="index">
            <k-input :class="css.inputW2" placeholder="请输入属性值" block clearable v-model="item.value"></k-input>
            <k-button type="danger" @click="onDelete(index)">删除</k-button>
            <y-button icon="k-icon-add" @click="onAddAttribute" type="primary" v-if="index + 1 == valueList.length">添加属性值</y-button>
          </div>
        </y-form-item>
        <y-form-item title="状态:" required>
          <div>
            <k-radio v-model="editPara.isEnabled" :value="true">启用</k-radio>
            <k-radio v-model="editPara.isEnabled" :value="false">停用</k-radio>
          </div>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import { NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_SAVE, NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_UPDATE, NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_DETAIL } from "@/assets/modules/apiList";

const initEditPara = () => ({
  id: "",
  name: "",
  valueList: [],
  isEnabled: true,
});
export default {
  data() {
    return {
      isLoading: false,
      editPara: initEditPara(),
      valueList: [],
      isSaving: false,
      isView: false,
      isEdit: false,
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let name = para.name.toString().replace(/\s*/g, "");
        if (name.length < 2 || name.length > 20 || para.isEnabled == null || this.valueList.length === 0) {
          status = true;
        }
      }
      return status;
    },
  },
  methods: {
    getAttributeDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_DETAIL,
        para: { id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.editPara.valueList = [];
          res.values.forEach((item) => {
            this.valueList.push({ value: item });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "attributeList",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      delete para.values;
      this.valueList.forEach((item) => {
        para.valueList.push(item.value);
      });
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_UPDATE : NESTLE_GOODS_BACK_SERVER_GOODS_ATTRIBUTE_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          this.onCancel(true, true);
          tip("操作成功");
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onDelete(index) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该属性值？",
        ok: () => {
          this.valueList.splice(index, 1);
        },
      });
    },
    onAddAttribute() {
      this.valueList.push({ value: "" });
    },
  },
  created() {
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getAttributeDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    this.valueList = [];
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getAttributeDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 400px !important;
}
.inputW2 {
  width: 400px !important;
  display: inline-block !important;
  margin: 0 30px 10px 0;
}
.btnW {
  width: 110px;
}
</style>
